var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tweetsData),function(tweet){return _c('div',{key:tweet.id},[_c('TweetItem',{attrs:{"tweetItem":tweet,"showName":_vm.showName}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }